import React, { useContext, useEffect, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";

import { FaPeopleGroup } from 'react-icons/fa6';
import { MdNotificationsNone, MdCalendarMonth, MdArrowRightAlt, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown, IoMdClose } from 'react-icons/io';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { SiHandshake } from 'react-icons/si';
import { AiOutlineQuestionCircle, AiFillFolder, AiOutlinePlusCircle, AiOutlineSearch } from 'react-icons/ai'
import { FaFilter } from "react-icons/fa6";
import { MdFilterListAlt } from "react-icons/md";

import { FaRegCircle } from 'react-icons/fa';
import Renderif from '../../components/renderif';
import { useNavigate } from 'react-router-dom';
import SideMenu from '../../components/sidemenu';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import Quiz from '../../components/quiz';
import Calendar from 'react-calendar';
import BVCalendar from '../../components/calendar';
import Slider from '../../components/slider';
import { gray10, gray20, gray30, gray40, primary } from '../../utils/colors';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { AuthContext } from '../../context/auth_context';
import AlertNotification from '../../components/alert-notification';
import { Service } from '../../services/api';
import TipCard from '../../components/tipcard';
import CheckBox from '../../components/checkbox';
import { GoGear } from 'react-icons/go';

export default function DocumentosClient() {

  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [state, setState] = useState({
    docs: [],
    tab: 0,
    show_agendar_cita: false,
    show_onboarding: user.onboarding === "" || user.onboarding === null ? true : false,
    tips: [
      {
        image: 'https://picsum.photos/200/300',
        title: 'Titulo',
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
      }
    ]
  })



  useEffect(() => {

    init();

    return () => { }
  }, [])


  const init = async () => {
    let _documents = await Service('GET', `Document?PageNumber=1&PageSize=999`);
    console.log(_documents);
    // setState({...state, docs:_documents.data.data})
  };





  return (
    <div className='container-fluid d-flex h-100'>

      <SideMenu></SideMenu>





      <div className='container-fluid d-flex flex-column  h-100'>

        <div className='d-flex flex-column flex-lg-row  bg-white p-2 p-sm-3 '>
          <div className='d-flex align-items-center'>
            <div className='input--light-curve'>
              <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
              <input placeholder='Busca Tips, Documentos, etc.'></input>
            </div>
          </div>
          <div className='col'></div>

          <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

            <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
              <div className='pe-2 cita-button flex-center'>
                <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                  // setState({ ...state, show_agendar_cita: true })
                  navigate('/client/crear-cita')
                }}>
                  <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                  Agendar cita
                </div>
              </div>
              <div className='pe-2'>
                <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                  if (state.notifications_menu) {
                    setState({ ...state, notifications_menu: false })
                  } else {
                    setState({ ...state, notifications_menu: true })
                  }

                }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                  <Renderif isTrue={state.notifications_menu}>
                    <div className='float-menu'>
                      <div className='h-menu flex-center-left separator-h-bottom p-2'>
                        Notificaciones
                      </div>
                      <div className='b-menu'>
                        <div className='card-notification d-flex separator-h-top'>
                          <div className=''>
                            <div className='avatar-profile'></div>
                          </div>
                          <div className='flex-center f-12 p-2'>
                            Por el momento no cuenta con notificaciones
                          </div>
                        </div>
                        {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div> */}
                      </div>
                    </div>
                  </Renderif>
                </div>
              </div>

              <div className='pe-2 me-4 agreements'>
                <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                  if (state.agreements_menu) {
                    setState({ ...state, agreements_menu: false })
                  } else {
                    setState({ ...state, agreements_menu: true })
                  }

                }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                  <Renderif isTrue={state.agreements_menu}>
                    <div className='float-menu'>
                      <div className='h-menu flex-center-left separator-h-bottom p-2'>
                        Acuerdos pendientes
                      </div>
                      <div className='b-menu'>
                        <div className='card-notification d-flex separator-h-top'>
                          <div className='flex-center ms-2'>
                            <FaRegCircle size={13} color={primary}></FaRegCircle>
                          </div>
                          <div className='flex-center f-12 p-2'>
                            Por el momento no cuenta con acuerdos
                          </div>
                        </div>
                        {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Hacer ejercicio
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Leer
                                                            </div>
                                                        </div> */}
                      </div>
                    </div>
                  </Renderif>
                </div>
              </div>

              <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                if (state.profile_menu) {
                  setState({ ...state, profile_menu: false })
                } else {
                  setState({ ...state, profile_menu: true })
                }

              }}>
                <div className='avatar-profile  ms-lg-3'></div>
                <div className=''>
                  <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                </div>

              </div>
              <Renderif isTrue={state.profile_menu}>
                <div className='float-menu-profile'>
                  <div className='b-menu'>
                    <div className='card-notification flex-center-j-left m-2'>
                      <div className=''>
                        <div className='avatar-profile'></div>
                      </div>
                      <div className='p-2'>
                        <div className='bold f-14'>
                          {user?.firstName} {user?.lastName}
                        </div>
                        <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                          navigate('/client/profile')
                        }}>
                          Mi perfil
                          <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='b-menu'>
                    <div className='card-notification d-flex separator-h-top cursor-pointer'>
                      <div className='flex-center ms-2'>
                        <GoGear size={15} color={gray40}></GoGear>
                      </div>
                      <div className='flex-center f-12 p-2'>
                        Configuración
                      </div>
                    </div>
                    <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                      logout();
                      navigate('/')
                    }}>
                      <div className='flex-center ms-2'>
                        <CgLogOut size={15} color={gray40} />
                      </div>
                      <div className='flex-center f-12 p-2'>
                        Cerrar sesión
                      </div>
                    </div>
                  </div>
                </div>
              </Renderif>
            </div>



          </div>
        </div>


        {/* MAQUETA VIEJA */}
        {/* <div className='col h-75 d-flex '>

          <div className='col-3 overflow-auto hide-scroll bg-light px-4 '>

            <div className='d-flex align-items-center bg-white r-10 p-2'>
              <div className='f-16 text-gray'></div>
              <div className='col'></div>
              <DropDown
                title={''}
                icon={<MdFilterListAlt size={20} color={gray30}></MdFilterListAlt>}>

                <DropDownOption>
                  <div className='d-flex align-items-center px-2'>


                    <div className='text-dark f-16 bold'>Filtro</div>
                    <div className='col mx-5'></div>
                    <div className='bv-icon'><IoMdClose size={16} color={gray40}></IoMdClose></div>

                  </div>
                </DropDownOption>
                <DropDownOption disabled>
                  <div className='d-flex flex-column ps-2'>
                    <CheckBox checked={true} text="Asignados"></CheckBox>
                    <CheckBox checked={true} text="Nuevo"></CheckBox>
                    <CheckBox checked={true} text="Fecha Ascendente"></CheckBox>
                    <CheckBox checked={true} text="Fecha Descendente"></CheckBox>

                  </div>
                </DropDownOption>
                <DropDownOption>
                  <div className='d-flex align-items-center ps-2'>
                    <div className='col'></div>
                    <div className='f-14  bold text-blue'> Aplicar filtro</div>
                    <div className='bv-icon'><MdOutlineKeyboardArrowRight color={gray40}></MdOutlineKeyboardArrowRight></div>
                  </div>
                </DropDownOption>

              </DropDown>
            </div>


            {state.docs.map((item, i) => {
              return (
                <div className='bv-card py-1 mt-2  py-2' >
                  <div className='d-flex align-items-center'>
                    <div className='bv-icon'><IoIosDocument color={gray30}></IoIosDocument></div>
                    <div className='f-14 text-gray bold cursor-pointer' onClick={() => {
                      window.open(item.documentUrl, '_blank')
                    }}>{item.title}</div>


                  </div>


                </div>
              )
            })}



            <div className='my-5'></div>



          </div>
          <div className='col-9 overflow-auto hide-scroll px-4 '>

            <div className='container'>

              <div className='position-relative'>
                <img width="100%" className='mx-auto' src='/assets/bannerdocs.png'></img>

                <div className='position-absolute absolute-center-left ps-4 '>
                  <div className='f-30 bolder line-0'>Explora Nuestro Universo de <br></br> Bienestar y Psicología</div>
                  <br></br>
                  <div className='f-18'>En BienVivir, te ofrecemos una variedad de consejos y <br></br> recursos para fortalecer tu salud mental y tu bienestar. <br></br> Nuestra misión es brindarte herramientas valiosas para<br></br>  una vida más saludable y equilibrada.</div>
                </div>
              </div>



            </div>

          </div>


        </div> */}
        {/* MAQUETA VIEJA */}

        {/* MQUETA NUEVA */}
        <div className='d-flex py-4'>
          <div className='col-sm-4 col-1'></div>
          <div className='txt-center col-sm-4 col-10'>
            <div className='h2 my-4'>
              Documentos
            </div>
            <div className='my-4'>
              Échale un vistazo a estos recursos que tenemos para ofrecer. Seguro encuentras algo útil que le agregue valor a tu vida
            </div>
            <div className='flex-center'>
              <div className='float-search '>
                <div className='input--light-curve bg-white'>
                  <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                  <input placeholder='Busca por tema de interes'></input>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-4 col-1'></div>
        </div>
        <div className='d-flex my-4'>
          <div className='col-1'></div>
          <div className='col-10 my-4'>
            <div className='d-flex scrollmenu'>
              <div className='bv-cta-curve-small bv-cta--primary-black bv-icon bv-icon--mid m-2'>Tips para tí</div>
              <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2'>Salud mental</div>
              <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2'>Estrés laboral</div>
            </div>
            <div className='grid-4 gap-4 my-4'>

              {/* {state.docs.map((item, i) => {
                return (
                  <div className='bv-card py-1 mt-2  py-2' >
                    <div className='d-flex align-items-center'>
                      <div className='bv-icon'><IoIosDocument color={gray30}></IoIosDocument></div>
                      <div className='f-14 text-gray bold cursor-pointer' onClick={() => {
                        window.open(item.documentUrl, '_blank')
                      }}>{item.title}</div>


                    </div>


                  </div>
                )
              })} */}

              {state.docs.map((item, i) => {
                return (
                  <div className='bv-card py-3 px-4 cursor-pointer' onClick={() => {
                    window.open(item.documentUrl, '_blank')
                  }}>
                    <div className='bold'>
                      {item.title}
                    </div>
                    <div className='txt-gray'>
                      por Dr. Ray Marqueda
                    </div>
                  </div>
                )
              })}

              <div className='bv-card py-3 px-4 cursor-pointer'>
                <div className='bold'>
                  Sintomas de la depresión
                </div>
                <div className='txt-gray'>
                  por Dr. Ray Marqueda
                </div>
              </div>

            </div>
          </div>
          <div className='col-1'></div>
        </div>
        {/* MQUETA NUEVA */}




      </div>


    </div>
  )
}
